<template>
    <v-stepper :steps="step" class="pf-mobile-stepper">
        <v-stepper-header>
            <v-stepper-step :complete="steps > 0" step=""></v-stepper-step>
            <v-stepper-step :complete="steps > 1" step=""></v-stepper-step>
            <v-stepper-step :complete="steps > 2" step=""></v-stepper-step>
            <v-stepper-step :complete="steps > 3" step=""></v-stepper-step>
            <v-stepper-step :complete="steps > 4" step=""></v-stepper-step>
            <v-stepper-step :complete="steps > 5" step=""></v-stepper-step>
            <v-stepper-step :complete="steps > 6" step=""></v-stepper-step>
        </v-stepper-header>
    </v-stepper>
</template>

<script>
    export default {
        name: "MobileStepper",
        data(){
            return{
                step: ''

            }
        },
        props: ['steps'],
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pathfinder/components/shared/MobileStepper.vue